var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { Agency, Project } from '../../../models/index';
import { MapPlanBase } from './map-plan-base.model';
import { ListTrackingService } from './../../../utils/list-tracking.service';
var MapPlanProjectBaseComponent = /** @class */ (function (_super) {
    __extends(MapPlanProjectBaseComponent, _super);
    function MapPlanProjectBaseComponent(zone, window, listTrackingService) {
        var _this = _super.call(this, zone, window) || this;
        _this.zone = zone;
        _this.window = window;
        _this.listTrackingService = listTrackingService;
        return _this;
    }
    MapPlanProjectBaseComponent.prototype.ngAfterViewInit = function () {
        this.runImgMappingScript();
    };
    MapPlanProjectBaseComponent.prototype.ngOnDestroy = function () {
        this.removeImgMappingScript();
    };
    return MapPlanProjectBaseComponent;
}(MapPlanBase));
export { MapPlanProjectBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-project-base.component.ts.pre-build-optimizer.js